export default "__VITE_ASSET__DgX84jpD__"